import { useMemo } from 'react';
import { useSearch } from '@tanstack/react-router';
import { EnterpriseIntegration, SwedishCashRegistersGetAllResult } from '@mews-commander/data-access';
import { FilterFormKeys, FilterFormValues } from './filterSchema';
import { useGetTodayISO } from './useGetTodayISO';

interface Props {
    enterpriseIntegrations?: EnterpriseIntegration[];
    cashRegisters?: SwedishCashRegistersGetAllResult;
}
// Hook to get the filter schema and default values
export const useDefaultFilterValues = ({ enterpriseIntegrations, cashRegisters }: Props) => {
    const todayISO = useGetTodayISO();

    // Get the validated search params from the route
    const search = useSearch({
        from: '/_authenticated/$currentEnterpriseId/SwedishFiscalReport/',
    });

    const swedishIntegrationId = search[FilterFormKeys.swedishIntegrationId] || enterpriseIntegrations?.[0]?.id || '';
    const cashRegisterId = search[FilterFormKeys.cashRegisterId] || cashRegisters?.[0]?.id || '';
    const defaultFilterValues = useMemo(() => {
        return {
            dateFrom: search[FilterFormKeys.dateFrom] || todayISO,
            dateTo: search[FilterFormKeys.dateTo] || todayISO,
            cashRegisterId,
            swedishIntegrationId,
        } as FilterFormValues;
    }, [search, todayISO, cashRegisterId, swedishIntegrationId]);

    return defaultFilterValues;
};
